// extracted by mini-css-extract-plugin
export var logoContainer = "logoContainer-module--logo-container--sEPQ8";
export var logoText = "logoContainer-module--logo-text--bNosf";